module.exports = __webpack_public_path__ + "static/img/DAMIEN_MARTYN.a57c622.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DAMIEN_MARTYN.jpg
// module id = jVo2
// module chunks = 0